import React from 'react';

const LANGS = [
  { code: 'de', flag: '🇩🇪', native: 'Deutsch',    sub: 'Deutsch' },
  { code: 'uk', flag: '🇺🇦', native: 'Українська', sub: 'Ukrainisch' },
  { code: 'ru', flag: '🇷🇺', native: 'Русский',    sub: 'Russisch' },
];

export default function LanguageSelector({ onSelect }) {
  const [active, setActive] = React.useState(null);

  return (
    <>
      <style>{`
        html, body { margin: 0; padding: 0; height: 100%; }
        .lang-wrap {
          min-height: 100dvh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(160deg, #1a2332 0%, #3E4954 60%, #2a3a4a 100%);
          padding: 24px 20px;
          box-sizing: border-box;
        }
        .lang-inner {
          width: 100%;
          max-width: 420px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .lang-logo {
          width: 120px;
          height: auto;
          display: block;
          margin: 0 auto 28px;
        }
        .lang-title {
          color: #fff;
          font-size: clamp(20px, 5vw, 26px);
          font-weight: 700;
          font-family: Georgia, serif;
          text-align: center;
          margin: 0 0 8px;
          letter-spacing: -0.02em;
          line-height: 1.25;
        }
        .lang-sub {
          color: rgba(255,255,255,0.55);
          font-size: clamp(12px, 3.5vw, 14px);
          font-family: system-ui, -apple-system, sans-serif;
          text-align: center;
          margin: 0 0 36px;
          line-height: 1.5;
        }
        .lang-cards {
          display: flex;
          flex-direction: column;
          gap: 12px;
          width: 100%;
        }
        .lang-btn {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 18px 20px;
          background: rgba(255,255,255,0.08);
          border: 2px solid rgba(255,255,255,0.14);
          border-radius: 16px;
          cursor: pointer;
          transition: background 180ms ease, border-color 180ms ease, transform 180ms ease;
          width: 100%;
          text-align: left;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
        .lang-btn:active {
          transform: scale(0.98);
          background: rgba(255,255,255,0.18);
          border-color: rgba(255,255,255,0.5);
        }
        @media (hover: hover) {
          .lang-btn:hover {
            background: rgba(255,255,255,0.14);
            border-color: rgba(255,255,255,0.4);
            transform: translateY(-2px);
          }
        }
        .lang-flag {
          font-size: 38px;
          line-height: 1;
          flex-shrink: 0;
        }
        .lang-text { flex: 1; min-width: 0; }
        .lang-native {
          color: #fff;
          font-weight: 700;
          font-size: clamp(16px, 4.5vw, 19px);
          font-family: system-ui, -apple-system, sans-serif;
          line-height: 1.2;
        }
        .lang-label {
          color: rgba(255,255,255,0.45);
          font-size: 13px;
          font-family: system-ui, -apple-system, sans-serif;
          margin-top: 2px;
        }
        .lang-arrow {
          color: rgba(255,255,255,0.35);
          flex-shrink: 0;
          transition: transform 180ms ease, color 180ms ease;
        }
        .lang-btn:active .lang-arrow {
          transform: translateX(4px);
          color: rgba(255,255,255,0.8);
        }
        .lang-footer {
          color: rgba(255,255,255,0.25);
          font-size: 11px;
          font-family: system-ui, sans-serif;
          text-align: center;
          margin-top: 32px;
        }
      `}</style>

      <div className="lang-wrap">
        <div className="lang-inner">
          {/* Logo — centered */}
          <img
            src="https://zba.academy/wp-content/uploads/zba-logo-weiss.png"
            alt="ZBA Academy"
            className="lang-logo"
          />

          <h1 className="lang-title">Sprache · Мова · Язык</h1>
          <p className="lang-sub">
            Bitte wähle deine Sprache<br />
            Оберіть мову · Выберите язык
          </p>

          <div className="lang-cards">
            {LANGS.map(lang => (
              <button
                key={lang.code}
                className="lang-btn"
                onClick={() => onSelect(lang.code)}
                onTouchStart={() => setActive(lang.code)}
                onTouchEnd={() => setActive(null)}
              >
                <span className="lang-flag">{lang.flag}</span>
                <div className="lang-text">
                  <div className="lang-native">{lang.native}</div>
                  <div className="lang-label">{lang.sub}</div>
                </div>
                <svg className="lang-arrow" width="20" height="20" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="2.5"
                  strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </button>
            ))}
          </div>

          <p className="lang-footer">ZBA – Zentrale Brandschutztechnik-Akademie GmbH</p>
        </div>
      </div>
    </>
  );
}
